import React from 'react';
import ReactDOM from 'react-dom';
import indexStyles from './index.scss';
import './i18n';
import { changeLanguage } from 'i18next';
import App from './App';

void indexStyles;

const EXTERNAL_STYLE_URLS = [
  'https://www.mazda.ca/globalassets/static/css/main.min.css?v=3e9573f05f5b73c8c6278fb61271a1ee1',
  'https://www.mazda.ca/globalassets/static/css/first.min.css?v=3e9573f05f5b73c8c6278fb61271a1ee1',
];

const SUPPORTED_LANGUAGES = ['en', 'fr'] as const;

type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

const resolveSupportedLanguage = (language: string): SupportedLanguage | null => {
  const normalized = language.trim().toLowerCase();
  if (!normalized) {
    return null;
  }

  const baseLanguage = normalized.split('-')[0];
  if (!SUPPORTED_LANGUAGES.includes(baseLanguage as SupportedLanguage)) {
    return null;
  }

  return baseLanguage as SupportedLanguage;
};

const syncLanguageFromHost = () => {
  if (window.parent === window) {
    return;
  }

  try {
    const hostLang = window.parent.document.documentElement.lang;
    const resolvedLang = resolveSupportedLanguage(hostLang);

    if (!resolvedLang) {
      return;
    }

    document.documentElement.lang = resolvedLang;
    void changeLanguage(resolvedLang);
  } catch {
    // Ignore cross-origin iframe access errors.
  }
};

const loadExternalStyles = () => {
  EXTERNAL_STYLE_URLS.forEach((href) => {
    if (document.head.querySelector(`link[data-external-style="${href}"]`)) {
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-external-style', href);
    document.head.appendChild(link);
  });
};

loadExternalStyles();
syncLanguageFromHost();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);


